/**
 * useProvider Hook
 * Custom hook for accessing provider context
 */

import { useContext } from 'react';
import ProviderContext from '../context/ProviderContext';

export function useProvider() {
  const context = useContext(ProviderContext);
  
  if (!context) {
    throw new Error('useProvider must be used within a ProviderProvider');
  }
  
  return context;
}

export default useProvider;

